// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export const ImageContainer = styled.span`
  display: block;
  width: 100%;
  height: 0;
  padding-top: ${Math.ceil((158 / 128) * 100)}%;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .overlay-badge {
    position: absolute;
    top: 0;
    right: 0;
    box-sizing: border-box;
    padding: 6px 3px 4px;
    filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.12));
    display: flex;
    flex-direction: column;
    width: 28px;
    height: 39px;

    .svg-background {
      position: absolute;
      top: 0;
      right: 0;
      z-index: -1;
    }

    .svg-background.tablet {
      display: block;
    }
    .svg-background.desktop {
      display: none;
    }

    .top-label {
      color: #020202;
      text-align: center;
      font-family: Nunito;
      font-size: 8px;
      font-style: normal;
      font-weight: 700;
      line-height: 9px;
      text-transform: uppercase;
    }

    .bottom-label {
      color: #020202;
      text-align: center;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 800;
      line-height: 15px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      width: 34px;
      height: 47px;
      padding: 8px 3px 10px;

      .top-label {
        font-size: 10px;
      }

      .bottom-label {
        font-size: 16px;
        line-height: 20px;
      }

      .svg-background.tablet {
        display: none;
      }
      .svg-background.desktop {
        display: block;
      }
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    padding-top: ${Math.ceil((292 / 217) * 100)}%;
    margin-bottom: 12px;
  }
`;
export default css`
  &.trending-in-category-recommendation-tile {
    box-sizing: border-box;
    min-width: 144px;
    max-width: 144px;
    padding: 8px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.12);
    align-self: flex-start;

    .recommendation-tile-atc-icon {
      margin-right: 0;
    }

    :last-child {
      margin-right: 4px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      min-width: 245px;
      max-width: 245px;
      padding: 14px;
      box-shadow: unset;
      filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.12));

      :last-child {
        margin-right: 16px;
      }
    }
  }
`;
